import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import CreateReportButton from "src/components/shared/Reports/CreateReportButton";
import { ButtonsWrapper, PageContainer } from "src/styled";

const VesselReports = () => {
  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          <CreateReportButton redirectUrl="/management/reports/add-report" />
        </ButtonsWrapper>
      </Breadcrumbs>
    </PageContainer>
  );
};
export default VesselReports;
